import * as React from "react";

import Flags from "country-flag-icons/react/3x2";
import styled from "styled-components";

let FlagWrapper = styled.span`
    display: inline-block;
    width: ${(props) => props.size}px;
    margin: 0 0.5rem;
`;

const nothing = () => <></>;
const RenderFlag = ({ country, size }) => {
    return <FlagWrapper size={size}>{(Flags[country] || nothing)({ title: "" })}</FlagWrapper>;
};

export default RenderFlag;
